export default __webpack_public_path__ + "static/media/36I-114289_-21015_0.8c26fdac.jpg";